module.exports = __webpack_public_path__ + "img/img_logo.f1aede3e.png";